import API from '../../../../../services/api';

export const INCIDENCIA_STEPS_API = {
    get: async () => {
        return API.get('/incidencia_steps').then(res => res.data);
    },
    new: async (step) => {
        return API.post('/incidencia_steps', step).then(res => res.data);
    },
    update: async (step) => {
        return API.put(`/incidencia_steps/${step.id}`, step).then(res => res.data);
    },
    delete: async (stepId) => {
        return API.delete(`/incidencia_steps/${stepId}`).then(res => res.data);
    }
}